'use client';

import { TUserInfoStore, useUserInfoStore } from '@entities/user';

export const UserInfoProvider = ({
  userInfo,
  children,
}: {
  userInfo: TUserInfoStore | undefined;
  children: React.ReactNode;
}) => {
  const setUserInfo = useUserInfoStore((state) => state.setter);
  setUserInfo(userInfo);
  return <>{children}</>;
};
